import React from "react";
import styled from "styled-components";

const GameFormatInfo = ({ gamesFormat, playerA, playerB, isPublic }) => {
  return (
    <SectionCard>
      <SectionHeader>A JUGAR</SectionHeader>
      <PlayInfoGrid>
        <PlayInfoLeft>
          <FormatBadge>{gamesFormat}</FormatBadge>
          <FormatDesc>
            {gamesFormat === "PA3"
              ? "(se juegan las 3 partidas)"
              : gamesFormat === "BO5"
              ? "(se juega al mejor de 5)"
              : "(se juega una sola partida)"}
          </FormatDesc>
          {gamesFormat !== "BO1" ? (
            <GameOrderLabel>Orden de juego:</GameOrderLabel>
          ) : null}
          {gamesFormat === "PA3" ? (
            <GameOrderList>
              <GameOrderItem>
                <GameOrderNum>1</GameOrderNum> Mapa neutral
              </GameOrderItem>
              <GameOrderItem>
                <GameOrderNum>2</GameOrderNum> Perdedor elige siguiente mapa
              </GameOrderItem>
              <GameOrderItem>
                <GameOrderNum>3</GameOrderNum> Último mapa que queda
              </GameOrderItem>
            </GameOrderList>
          ) : null}
          {gamesFormat === "BO5" ? (
            <GameOrderList>
              <GameOrderItem>
                <GameOrderNum>1</GameOrderNum> HM de {playerA?.username}
              </GameOrderItem>
              <GameOrderItem>
                <GameOrderNum>2</GameOrderNum> HM de {playerB?.username}
              </GameOrderItem>
              <GameOrderItem>
                <GameOrderNum>3</GameOrderNum> Mapa neutral
              </GameOrderItem>
              <GameOrderItem>
                <GameOrderNum>4</GameOrderNum> HM del que vaya perdiendo
              </GameOrderItem>
              <GameOrderItem>
                <GameOrderNum>5</GameOrderNum> HM restante
              </GameOrderItem>
            </GameOrderList>
          ) : null}
        </PlayInfoLeft>
        {!isPublic ? (
          <PlayInfoRight>
            <PlayInfoTitle>Temas a tener en cuenta:</PlayInfoTitle>
            <PlayInfoItem>{">"} Poned la partida PÚBLICA</PlayInfoItem>
            <PlayInfoItem>
              {">"} Uníos a un canal de voz de la liga. Es OBLIGATORIO.
            </PlayInfoItem>
          </PlayInfoRight>
        ) : null}
      </PlayInfoGrid>
    </SectionCard>
  );
};

const SectionCard = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.25rem;
`;

const SectionHeader = styled.h4`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-mint);
  margin: 0 0 0.75rem;
`;

const PlayInfoGrid = styled.div`
  display: flex;
  gap: 1rem;
`;

const PlayInfoLeft = styled.div`
  flex: 1;
`;

const FormatBadge = styled.span`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--v-gold);
  border: 1px solid rgba(201, 160, 78, 0.3);
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
`;

const FormatDesc = styled.p`
  font-family: var(--v-font-body);
  font-size: 12px;
  color: var(--v-fg-muted);
  margin: 0.4rem 0;
`;

const GameOrderLabel = styled.p`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-fg-muted);
  margin: 0.75rem 0 0.5rem;
`;

const GameOrderList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const GameOrderItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--v-font-body);
  font-size: 13px;
  color: var(--v-fg);
`;

const GameOrderNum = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-family: var(--v-font-mono);
  font-size: 11px;
  font-weight: 600;
  color: var(--v-mint);
  border: 1px solid var(--v-mint);
  flex-shrink: 0;
`;

const PlayInfoRight = styled.div`
  width: 35%;
  padding: 0.75rem;
  border: 1px solid rgba(255, 59, 59, 0.2);
  border-radius: 12px;
`;

const PlayInfoTitle = styled.p`
  font-family: var(--v-font-mono);
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-fg-muted);
  margin: 0 0 0.5rem;
`;

const PlayInfoItem = styled.p`
  font-family: var(--v-font-body);
  font-size: 11px;
  color: var(--v-fg);
  margin: 0.2rem 0;
`;

export default GameFormatInfo;
